var React = require('react');

function NeArrowWhite (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ne-arrow"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"ne-arrow","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M17.7894491,5 L8.12578323,5 L8.12578323,0 L26.1880772,0 L26.1880772,18 L21.1880772,18 L21.1880772,8.67243977 L3.53553391,26.324983 L-4.97379915e-14,22.7894491 L17.7894491,5 Z","id":"Combined-Shape","fill":"#FFFFFF","fillRule":"nonzero"}))]);
}

NeArrowWhite.defaultProps = {"width":"27px","height":"27px","viewBox":"0 0 27 27","version":"1.1"};

module.exports = NeArrowWhite;

NeArrowWhite.default = NeArrowWhite;
